import React, { useState, useEffect, useCallback } from 'react';
import PropTypes from 'prop-types';
import { Button } from 'reactstrap';
import { CalculatorStepItem } from 'site-modules/calculators/components/calculator-step-item/calculator-step-item';
import { CalculatorRowItem } from 'site-modules/calculators/components/calculator-row-item/calculator-row-item';
import { PaymentInput } from 'site-modules/shared/components/calculator/payment-input/payment-input';
import { PAYMENT_INPUT_PROPS } from 'site-modules/calculators/constants/calculators';
import { TradeInAppraiserDrawer } from 'site-modules/shared/components/appraisal/trade-in-appraiser/trade-in-appraiser-drawer';
import { VehicleSelectorView } from 'site-modules/calculators/components/vehicle-selector-view/vehicle-selector-view';

export const GasGuzzlerTradeInStep = ({
  mpg,
  price,
  style = null,
  onKeyPress,
  onInputChange,
  onVehicleUpdate,
  onRemoveStyle,
  onTradeInPriceSave,
  isTradeInVehicleSelectorOpen = false,
}) => {
  const [isVehicleSelectorDrawerOpen, setIsVehicleSelectorDrawerOpen] = useState(false);
  const toggleVehicleSelectorDrawer = useCallback(() => {
    setIsVehicleSelectorDrawerOpen(state => !state);
  }, []);

  useEffect(() => {
    if (isTradeInVehicleSelectorOpen) {
      // eslint-disable-next-line react-hooks/set-state-in-effect -- this is intentionally client-only to avoid opening the drawer during SSR.
      toggleVehicleSelectorDrawer();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <CalculatorStepItem stepName="Select Your Gas Guzzler">
      {!style && (
        <CalculatorRowItem title="Select a vehicle for your Trade-In">
          <Button
            onClick={toggleVehicleSelectorDrawer}
            size="sm"
            color="outline-primary-b"
            className="text-transform-none"
          >
            Select Trade-In
          </Button>
        </CalculatorRowItem>
      )}
      <VehicleSelectorView style={style} onChange={toggleVehicleSelectorDrawer} onDelete={onRemoveStyle} />
      <CalculatorRowItem title="Value of Your Trade-In">
        <PaymentInput
          name="tradeInPrice"
          key={price}
          value={price}
          onKeyPress={onKeyPress}
          onBlur={onInputChange}
          isCurrency
          {...PAYMENT_INPUT_PROPS}
          inputAriaLabel="Value of Your Trade-In"
        />
      </CalculatorRowItem>
      <CalculatorRowItem title="MPG for your trade-in">
        <PaymentInput
          name="tradeInMpg"
          key={mpg}
          value={mpg}
          onKeyPress={onKeyPress}
          onBlur={onInputChange}
          {...PAYMENT_INPUT_PROPS}
          inputAriaLabel="MPG for your trade-in"
        />
      </CalculatorRowItem>
      <TradeInAppraiserDrawer
        isOpen={isVehicleSelectorDrawerOpen}
        onToggle={toggleVehicleSelectorDrawer}
        onTradeInUpdate={onTradeInPriceSave}
        onVehicleUpdate={onVehicleUpdate}
        trackingParent="calculator-appraisal-drawer"
      />
    </CalculatorStepItem>
  );
};

GasGuzzlerTradeInStep.propTypes = {
  mpg: PropTypes.number.isRequired,
  price: PropTypes.number.isRequired,
  style: PropTypes.shape({
    makeName: PropTypes.string,
    modelName: PropTypes.string,
    year: PropTypes.number,
    id: PropTypes.number,
    name: PropTypes.string,
  }),
  onKeyPress: PropTypes.func.isRequired,
  onInputChange: PropTypes.func.isRequired,
  onVehicleUpdate: PropTypes.func.isRequired,
  onRemoveStyle: PropTypes.func.isRequired,
  onTradeInPriceSave: PropTypes.func.isRequired,
  isTradeInVehicleSelectorOpen: PropTypes.bool,
};
